import { DetailFieldList } from "@/shared/components";
import { DetailSection } from "../../../detail-section";
import type { ComercialSectionViewModel } from "./types-comercial-section";

export function ComercialSectionView({
  id,
  title,
  testId,
  fieldsTestId,
  status,
  errorMessage,
  loadingMessage,
  emptyContent,
  onReauthenticate,
  onRetry,
  ultimaAtualizacao,
  fields,
}: ComercialSectionViewModel) {
  return (
    <DetailSection
      id={id}
      title={title}
      ultimaAtualizacao={ultimaAtualizacao}
      testId={testId}
      status={status}
      loadingMessage={loadingMessage}
      errorMessage={errorMessage}
      emptyContent={emptyContent}
      onReauthenticate={onReauthenticate}
      onRetry={onRetry}
    >
      <DetailFieldList testId={fieldsTestId} fields={fields} />
    </DetailSection>
  );
}
